import { AnonymousBullets } from "./AnonymousBullets";
import { SalariesTextField } from "./SalariesTextField";

import { Spacing } from "@otta/design";
import { required } from "@otta/search/utils/validators";
import { QuestionComponentProps } from "@otta/search/containers/Quiz";

export function SalaryInputJobTitle(
  props: QuestionComponentProps
): React.ReactElement {
  return (
    <Spacing>
      <SalariesTextField
        fieldName="currentJobTitle"
        label="Job title"
        validate={required}
        {...props}
      />
      <AnonymousBullets />
    </Spacing>
  );
}
